/*
  Footer menu accordions on phones (sections/ncf-site-footer.liquid).
  The toggle buttons only show below 750px, and only once this element is defined, so the
  lists stay open without JS. From 750px up the CSS shows every list whatever the state.
*/
if (!customElements.get('ncf-footer-accordion')) {
  customElements.define(
    'ncf-footer-accordion',
    class NcfFooterAccordion extends HTMLElement {
      connectedCallback() {
        this.onClick = this.onClick.bind(this);
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      onClick(event) {
        const button = event.target.closest('[data-footer-toggle]');
        if (!button || !this.contains(button)) return;

        const menu = button.closest('[data-footer-menu]');
        const open = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (menu) menu.classList.toggle('is-open', open);
      }
    }
  );
}
